<template>
	<div>
		<!-- 普通CheckBox -->
		<el-checkbox-group @change="onChange" v-model="child_defaultValue">

			<el-checkbox v-if="optionData&&JSON.stringify(optionData)!='[]'" v-for='(item,index) in optionData'
				:key='index' :label="item[field.defaultProps.value]">
				{{item[field.defaultProps.label]}}
			</el-checkbox>

		</el-checkbox-group>
	</div>
</template>

<script>
	import Common from './js/Common'

	export default {
    name: 'sls-checkbox',
    mixins:[Common],
		data() {
			return {
        inital_defaultValue:[],
        child_defaultValue:[],
			}
		},
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/solely-fields/SlsCheckbox.vue